import { render, staticRenderFns } from "./SubirDocumentacion.vue?vue&type=template&id=75cc5d5d&scoped=true"
import script from "./SubirDocumentacion.vue?vue&type=script&lang=ts"
export * from "./SubirDocumentacion.vue?vue&type=script&lang=ts"
import style0 from "./SubirDocumentacion.vue?vue&type=style&index=0&id=75cc5d5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cc5d5d",
  null
  
)

export default component.exports